import * as React from 'react';
import * as Sentry from '@sentry/browser';
import { History } from 'history';

export interface IErrorBoundaryState {
  error: null | boolean;
  info: any
}

export interface IErrorBoundaryProps {
  history: History;
  username: string;
}

const initialState = {
  error: null,
  info: null
};

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = initialState;
  }

  public componentDidCatch(error, info) {
    this.setState({ error: true });
    Sentry.withScope(scope => {
      scope.setExtras(info);
      scope.setUser({ email: this.props.username })
      Sentry.captureException(error);
    });
  }
  public goToHome = async () => {
    this.props.history.replace('/')
    await new Promise((res) => this.setState(initialState, res));
  }

  public render() {
    if (this.state.error) {
      return (
        <div className="error-card white-background">
          <h3>Something went wrong! Our dev team has been informed of the issue</h3>
          <button
            className="btn-blue"
            onClick={this.goToHome}>Index page</button>
        </div>
      )
    }
    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/share/components/ErrorPage/ErrorBoundary.tsx